(function() {
  var handle = window.location.pathname.split('/products/')[1];
  if (!handle) return;
  handle = handle.split('?')[0].split('#')[0];

  var BUNDLES = {
    'the-styling-trio': [
      { id: 7645000499259,  quantity: 1 },
      { id: 42291019677865, quantity: 1 },
      { id: 42291054936233, quantity: 1 }
    ],
    'the-complete-kit': [
      { id: 42291054936233, quantity: 1 },
      { id: 7645000499259,  quantity: 1 },
      { id: 7645020225595,  quantity: 1 }
    ],
    'the-beard-routine': [
      { id: 44591452487849, quantity: 1 },
      { id: 7645020225595,  quantity: 1 },
      { id: 44591441543337, quantity: 1 }
    ]
  };

  var items = BUNDLES[handle];
  if (!items) return;

  function addBundleToCart(btn) {
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function() { window.location.href = '/cart'; })
    .catch(function() {
      if (btn) { btn.disabled = false; btn.textContent = orig; }
    });
  }

  function attachInterceptors() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
      if (form.dataset.bundleReady) return;
      form.dataset.bundleReady = '1';
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addBundleToCart(form.querySelector('[type="submit"]'));
      }, true);
    });

    document.querySelectorAll('.sticky-addtocart [type="submit"], #sticky-atc [type="submit"], [class*="sticky"] [type="submit"]').forEach(function(btn) {
      if (btn.dataset.bundleReady) return;
      btn.dataset.bundleReady = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addBundleToCart(btn);
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachInterceptors);
  } else {
    attachInterceptors();
  }
  new MutationObserver(attachInterceptors).observe(document.documentElement, { childList: true, subtree: true });
})();